import {migrateGridDocument} from "./migrations";
import {validateGridDocument, type GridDocument} from "./document";

// Hydration never consults current defaults. Future persisted versions require explicit migrations.
export function parseGridDocument(json: string): GridDocument {
  const value: unknown = migrateGridDocument(JSON.parse(json));
  validateGridDocument(value);
  return value;
}
export function serializeGridDocument(document: GridDocument): string {
  validateGridDocument(document);
  return JSON.stringify(document, null, 2);
}
